import { Cancel, Delete, Edit, Save } from '@mui/icons-material';
import { ButtonProps, Divider, IconButton, Tooltip } from '@mui/material';
import { TooltipProps } from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

type EditStateActionButtonProps = Partial<ButtonProps> & {
  'data-testid': string;
};

type EditStateActionsProps = {
  canEdit: boolean;
  readMode: boolean;
  onDelete?: ButtonProps['onClick'];
  onSave: ButtonProps['onClick'];
  onCancel: ButtonProps['onClick'];
  onEdit: ButtonProps['onClick'];
  slotProps?: {
    edit?: EditStateActionButtonProps;
    save?: EditStateActionButtonProps;
    cancel?: EditStateActionButtonProps;
    delete?: EditStateActionButtonProps;
  };
};

export const EditStateActions = (props: EditStateActionsProps) => {
  const { canEdit, readMode, onEdit, onSave, onCancel, onDelete, slotProps } =
    props;

  const { t } = useTranslation();

  const tooltipProps: Partial<TooltipProps> = {
    placement: 'top',
    arrow: true,
  };

  return (
    <>
      {canEdit && (
        <>
          {readMode ? (
            <Tooltip title={t('laEdit')} {...tooltipProps}>
              <IconButton
                data-testid={'editStateAction_edit'}
                {...slotProps?.edit}
                onClick={onEdit}
                size={'small'}
                color={'primary'}
              >
                <Edit />
              </IconButton>
            </Tooltip>
          ) : (
            <>
              {!!onDelete && (
                <>
                  <Tooltip title={t('laClear')} {...tooltipProps}>
                    <IconButton
                      data-testid={'editStateAction_delete'}
                      {...slotProps?.delete}
                      onClick={onDelete}
                      size={'small'}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  <Divider orientation={'vertical'} />
                </>
              )}
              <Tooltip title={t('laSave')} {...tooltipProps}>
                <IconButton
                  data-testid={'editStateAction_save'}
                  {...slotProps?.save}
                  onClick={onSave}
                  size={'small'}
                  color={'success'}
                >
                  <Save />
                </IconButton>
              </Tooltip>
              <Tooltip title={t('laCancel')} {...tooltipProps}>
                <IconButton
                  data-testid={'editStateAction_cancel'}
                  {...slotProps?.cancel}
                  onClick={onCancel}
                  size={'small'}
                  color={'error'}
                >
                  <Cancel />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      )}
    </>
  );
};
